import {
    DOCUMENT_SELECT_MODE,
    FETCH_ANALYSIS,
    PATCH_ANALYSIS,
    SAVE_ANALYSIS,
    SET_ACTIVE_DOCUMENT_ID,
    SET_CURRENT_QUESTION,
    SET_DOCUMENT_SELECTION,
    SET_DOCUMENT_SELECTION_NOTFOUND,
} from '../actions/AnalysisActions';

import { ROUTE_CHANGED } from '../actions/RouterActions';
import { getNextQuestionId } from '../../../helpers/QuestionnaireHelper';
import { matchPath } from 'react-router-dom';

// INITIALIZE STATE
const initialState = {
    analysis: null,
    currentQuestion: null,
    activeDocumentId: null,
    documentSelectMode: false,
    documentSelection: { start: null, end: null, text: null, documentId: null },
    documentSelectionNotFound: false,
    fetching: false,
    fetched: false,
    failed: false,
    newDocument: null,
};

// REDUCER
export const AnalysisReducer = (state = initialState, action) => {
    switch (action.type) {
        case ROUTE_CHANGED: {
            const { location } = action.payload;
            const isAddingDocument = matchPath(location.pathname, {
                path: '/analysis/addDocument',
                exact: true,
                strict: false,
            });
            let newDocument = null;
            new URLSearchParams(isAddingDocument ? location.search.slice(1) : '').forEach(
                (value, key) => {
                    if (!newDocument) {
                        newDocument = {};
                    }
                    newDocument[key] = value;
                }
            );
            return {
                ...state,
                newDocument,
            };
        }
        case `${FETCH_ANALYSIS}_PENDING`:
            return {
                ...state,
                analysis: null,
                currentQuestion: null,
                fetching: true,
                fetched: false,
                failed: false,
            };
        case `${FETCH_ANALYSIS}_FULFILLED`: {
            let currentQuestion = null;

            if (action.payload && action.payload.questions) {
                currentQuestion = action.payload.questions[0];

                // have any questions been answered already?
                if (action.payload.questionLog && action.payload.questionLog.length) {
                    // get last question answered
                    const lastQuestionId =
                        action.payload.questionLog[action.payload.questionLog.length - 1];
                    const lastQuestion = action.payload.questions.find(item => {
                        if (item.id === lastQuestionId) return item;
                    });

                    // get next question based on answer
                    const nextQuestionId = getNextQuestionId(
                        lastQuestion,
                        action.payload.answers[action.payload.answers.length - 1].answer
                    );
                    currentQuestion = action.payload.questions.find(item => {
                        if (item.id === nextQuestionId) return item;
                    });
                }
            }

            return {
                ...state,
                analysis: action.payload,
                currentQuestion: currentQuestion,
                documentSelectMode: false, //currentQuestion && currentQuestion.taggable,
                documentSelection: { start: null, end: null, text: null, documentId: null },
                fetching: false,
                fetched: true,
                failed: false,
            };
        }
        case `${FETCH_ANALYSIS}_REJECTED`:
            return {
                ...state,
                analysis: null,
                fetching: false,
                fetched: false,
                failed: true,
            };

        case `${PATCH_ANALYSIS}_PENDING`:
        case `${SAVE_ANALYSIS}_PENDING`:
            return {
                ...state,
                fetching: true,
                fetched: false,
                failed: false,
            };
        case `${SAVE_ANALYSIS}_FULFILLED`: {
            return {
                ...state,
                analysis: action.payload,
                fetching: false,
                fetched: true,
                failed: false,
            };
        }
        case `${PATCH_ANALYSIS}_REJECTED`:
        case `${SAVE_ANALYSIS}_REJECTED`:
            return {
                ...state,
                fetching: false,
                fetched: false,
                failed: true,
            };

        case SET_CURRENT_QUESTION:
            return {
                ...state,
                currentQuestion: action.payload,
            };

        case SET_DOCUMENT_SELECTION:
            return {
                ...state,
                documentSelection: action.payload,
            };

        case DOCUMENT_SELECT_MODE:
            return {
                ...state,
                documentSelectMode: action.payload,
            };

        case SET_ACTIVE_DOCUMENT_ID:
            return {
                ...state,
                activeDocumentId: action.payload,
            };

        case SET_DOCUMENT_SELECTION_NOTFOUND:
            return {
                ...state,
                documentSelectionNotFound: action.payload ? true : false,
            };

        case `${PATCH_ANALYSIS}_FULFILLED`:
            return {
                ...state,
                fetching: false,
                fetched: true,
                failed: false,
            };

        default:
            return state;
    }
};
